import { RenovationType } from '../types/Hotel';

export enum ChildServiceId {
    Animators = 9,
    Pool = 10,
    Menu = 11,
    Playroom = 12,
    Clubs = 16,
    Bed = 17,
    Nanny = 18,
}

export type ChildServiceOld =
    | 'children_animators'
    | 'children_pool'
    | 'children_childmenu'
    | 'children_childBed'
    | 'children_nanny'
    | 'children_clubs'
    | 'children_playroom';

export const CHILD_SERVICE_OLD_MAP: Record<ChildServiceId, ChildServiceOld> = {
    [ChildServiceId.Animators]: 'children_animators',
    [ChildServiceId.Pool]: 'children_pool',
    [ChildServiceId.Menu]: 'children_childmenu',
    [ChildServiceId.Bed]: 'children_childBed',
    [ChildServiceId.Nanny]: 'children_nanny',
    [ChildServiceId.Clubs]: 'children_clubs',
    [ChildServiceId.Playroom]: 'children_playroom',
};

export enum RestTypeId {
    Beach = 1,
    City = 2,
    Mountain = 3,
    Wellness = 4,
    Eco = 5,
}

export type RestTypeOld =
    | 'restBeach'
    | 'restCity'
    | 'mountains'
    | 'wellness'
    | 'eco';

export const REST_TYPE_OLD_MAP: Record<RestTypeId, RestTypeOld> = {
    [RestTypeId.Beach]: 'restBeach',
    [RestTypeId.City]: 'restCity',
    [RestTypeId.Mountain]: 'mountains',
    [RestTypeId.Wellness]: 'wellness',
    [RestTypeId.Eco]: 'eco',
};

export enum BeachTypeId {
    SandBeach = 1,
    PebbleBeach = 2,
    SandPebbleBeach = 3,
}

export type BeachTypeOld =
    | 'sandBeach'
    | 'pebbleBeach'
    | 'sandPebbleBeach';

export const BEACH_TYPE_OLD_MAP: Record<BeachTypeId, BeachTypeOld> = {
    [BeachTypeId.SandBeach]: 'sandBeach',
    [BeachTypeId.PebbleBeach]: 'pebbleBeach',
    [BeachTypeId.SandPebbleBeach]: 'sandPebbleBeach',
};

export interface IHotel {
    id: number;
    childServices: number[];
    restTypes: number[];
    beachType: number;
    renovationTypes: RenovationType[];
}
